import React from "react"
import Box from "@mui/material/Box"
import Drawer from "@mui/material/Drawer"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"

const MobileDrawer = ({ pages, mobileOpen, handleDrawerToggle, handleCloseNavMenu, selectedCategory }) => {
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        BlogSwipe
      </Typography>
      <List>
        {pages.map((page) => (
          <ListItem key={page} disablePadding>
            <Button
              fullWidth
              onClick={() => handleCloseNavMenu(page)}
              sx={{
                color: "text.primary",
                "&.active": {
                  backgroundColor: "primary.light",
                },
              }}
              className={page === selectedCategory ? "active" : ""}
            >
              <ListItemText primary={page} />
            </Button>
          </ListItem>
        ))}
      </List>
    </Box>
  )

  return (
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: "block", sm: "none" },
        "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
      }}
    >
      {drawer}
    </Drawer>
  )
}

export default MobileDrawer;

